<div tabindex="0" class="question" (click)="show()" (keypress)="show()"> <img [alt]= "expand ? 'collapse' : 'expand'" src="assets/images/chevron-down-blue.svg"  [class.arrow-up]="expand"  /> {{question}}</div>
@if (expand) {
  <div class="answer">
    @if (content) {
      <div [innerHTML]="content">
      </div>
    }
    <ng-content></ng-content>
  </div>
}
